{
  "name": "@ns/company-bank-transfer",
  "version": "1.0.0",
  "description": "Record the reference used for the manual bank transfer",
  "inputs": {
    "connectorCompanyId": {
      "type": "string"
    }
  },
  "outcomes": {
    "complete": {}
  }
}
